import React from 'react';
import { classes, useToggler } from '../../../lib';
import Styles from './BlogSubmenu.module.less';
import { CaretUpFilled, CaretDownFilled } from '@ant-design/icons';
import { BlogSubmenuLinks } from './BlogSubmenuLinks';
import { BlogSubmenuProps } from './BlogSubmenuDesktop';
import { BlogSearchForm } from '../BlogSearchForm/BlogSearchForm';

export const BlogSubmenuMobile = ({
    items,
    searchTerm,
    onSearch,
}: BlogSubmenuProps) => {
    const [isOpen, toggleMenu] = useToggler(false);
    return (
        <div className={classes(Styles.container)}>
            <div
                className={Styles.toggle}
                onClick={() => {
                    toggleMenu();
                }}>
                <strong>Blog</strong>
                <div>{isOpen ? <CaretUpFilled /> : <CaretDownFilled />}</div>
            </div>
            {isOpen && (
                <div className={Styles.mobileContent}>
                    <BlogSubmenuLinks
                        homeTitle="Página inicial"
                        items={items}
                    />
                    <BlogSearchForm
                        searchTerm={searchTerm}
                        onSearch={onSearch}
                    />
                </div>
            )}
        </div>
    );
};
